import { useMemo } from 'react'
import { form } from '../../formState'
import { useTexts } from './useTexts'

export function MobileFutureDaysVisibility() {
  const options = useMobileFutureDaysVisibilityOptions()
  const texts = useTexts()
  return (
    <>
      <form.SectionTitle variant="alternative">{texts.routeViewPreferences}</form.SectionTitle>

      <form.SimpleSelect
        name="mobileFutureDaysVisibility"
        testId="mobileFutureDaysVisibility"
        label={texts.mobileFutureDaysVisibility}
        validateOn="blur change"
        options={options}
      />
    </>
  )
}

function useMobileFutureDaysVisibilityOptions() {
  const texts = useTexts()

  return useMemo(() => {
    return [
      {
        value: '-1',
        label: texts.mobileFutureDaysVisibilityValues(-1),
      },
      {
        value: '2',
        label: texts.mobileFutureDaysVisibilityValues(2),
      },
    ]
  }, [texts])
}
